import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, map } from 'rxjs';
import { GetDecodedToken } from 'libs/core/src/lib/utils/token-decode';
import { RepresentativeService } from 'libs/core/src/lib/services/representative.service';
import { SystemUserRole } from '@inshuwa-client/models';

export const resolveRepresentative = () => {
  const insurerService = inject(RepresentativeService);
  const decoded = GetDecodedToken();

  if (!decoded) {
    inject(Router).navigate(['/'], { replaceUrl: true });
    return EMPTY;
  }

  const { id } = decoded;

  return insurerService.getInsurerRepresentativeById(Number(id)).pipe(
    map((value) => {
      localStorage.setItem(
        SystemUserRole.InsurerRepresentative,
        JSON.stringify(value),
      );
      return value;
    }),
  );
};
